import React from 'react';
import Image from '../../../assets/icons/van-404-error.png';
import history from '../../../history/history';
import { PrimaryBackButton } from '../../CTA/Buttons';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  ErrorContentRow,
  ErrorContentCol,
  ErrorHead,
  ErrorDetail,
  ErrorPara,
  Links,
  ErrorImage,
  FixedWidthContainer
} from './style';
import { getpwUrl, recordError } from "../../../utils/commonUtil";


const buttonStyle = {
  width: '250px',
  height: '50px',
  'font-family': 'helveticaNeueCondensedBlack',
  'font-size': '16px',
  'line-height': '30px',
  'letter-spacing': '1px',
  'border-radius': '0px',
  'margin-bottom': '40px'
};

function NotFoundComponent(props) {
  return (
    <FixedWidthContainer>
      <ErrorContentRow>
        <ErrorContentCol span={12}>
          <ErrorHead>404</ErrorHead>
          <ErrorDetail>
            Well, this is embarrassing.
            <br />
          </ErrorDetail>
          <ErrorPara>
            It looks like we can't find the page you wanted, but there are
            options. You could try our search feature, tap on the navigation
            links at the top of the page or head back to the homepage using the
            button below.
          </ErrorPara>
          <PrimaryBackButton
            id="btnTakeMeHome"
            styling=''
            buttonName='TAKE ME HOME'
            customStyle={buttonStyle}
            clicked={() => history.push('/')}
            ShowArrow={false}
          />
          <ErrorPara bottom>
            Access our <Links
            onClick={() => {
              try {
                window.open(getpwUrl() + "/sitemap");
              } catch (error) {
                recordError(error);
              }
            }}
            >
            Site Map</Links>
          </ErrorPara>
          <ErrorPara bottom>
            For further assistance, <Links
              onClick={() => {
                try {
                  window.open(getpwUrl() + "/contact-us");
                } catch (error) {
                  recordError(error);
                }
              }}
              >
             Contact Vanguard Charitable</Links>{' '}
            directly
          </ErrorPara>
        </ErrorContentCol>
        <ErrorContentCol imageSection span={12}>
          <ErrorImage src={Image} />
        </ErrorContentCol>
      </ErrorContentRow>
    </FixedWidthContainer>
  );
}

export default withRouter(
  connect(
    null,
    null
  )(NotFoundComponent)
);
